/* eslint-disable no-restricted-imports */
import { Box } from '@mui/material';
import { AccountFavoriteItem } from '@/components/content/Account/parts/AccountFavoriteItem';
import { useWishListDetails } from '@/data/Content/_WishListDetails';
import {
	WishlistWishlist,
	WishlistWishlistItem,
} from 'integration/generated/transactions/data-contracts';
import React, { useMemo } from 'react';
import { KeyedMutator } from 'swr';
import {
	AccountFavoriteItemSX,
	AccountFavoriteListFrameSX,
	AccountFavoriteListPaperSX,
} from '../styles/accountFavoriteList';
import { useProductsWithParent } from '@/data/Content/Products';
import { EmptyFavoriteProduct } from '@/components/blocks/EmptyFavoriteProduct';
import { ProductCardPLPSkeleton } from '@/components/content/CatalogEntryList/parts/ProductCardPLPSkeleton';

interface AccountFavoriteListProps {
	wishLists: WishlistWishlistItem;
	onDeleteWishList: (wishList: WishlistWishlistItem) => () => Promise<void>;
	onMutateWishLists: KeyedMutator<WishlistWishlist | undefined>;
	listType: 'favorites' | 'saved';
}

export const AccountFavoriteList: React.FC<AccountFavoriteListProps> = ({
	wishLists,
	onDeleteWishList,
	onMutateWishLists,
	listType,
}) => {
	const wishListDetails = useWishListDetails(wishLists, onDeleteWishList, onMutateWishLists);

	const partNumber = useMemo(() => {
		if (!wishLists?.item?.length) {
			return [];
		}

		return wishLists.item.map((item) => item.partNumber) ?? [];
	}, [wishLists?.item]);

	const { products, loading } = useProductsWithParent({
		partNumber,
	});

	if (loading || wishListDetails.isLoading) {
		return (
			<Box sx={AccountFavoriteListFrameSX}>
				{partNumber.map((_, i) => (
					<ProductCardPLPSkeleton key={i} isFavorite sx={AccountFavoriteItemSX} />
				))}
			</Box>
		);
	}

	if (products.length === 0) {
		return (
			<EmptyFavoriteProduct
				type={listType}
				variant="secondary"
				framesx={AccountFavoriteListPaperSX}
			/>
		);
	}

	return (
		<Box sx={AccountFavoriteListFrameSX}>
			{products.map((product) => (
				<AccountFavoriteItem
					key={product.id}
					product={product}
					productId={product.id ?? ''}
					onDeleteFromWishList={wishListDetails.onDeleteFromWishList}
					sx={AccountFavoriteItemSX}
				/>
			))}
		</Box>
	);
};
